module.exports = __webpack_public_path__ + "static/media/templeInside.e8d12979.jpg";